"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("lodash/get"));
Entry.BlockCountViewer = /*#__PURE__*/function () {
  function _class() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, _class);
    if (!Entry.codeChangedEvent) {
      Entry.codeChangedEvent = new Entry.Event(window);
    }
    var updateView = function updateView() {
      Entry.Utils.clearObjectsBlocksForEventThread();
      _this.updateView();
    };
    Entry.codeChangedEvent.attach(this, updateView);
    Entry.addEventListener('loadComplete', updateView);
  }
  return (0, _createClass2["default"])(_class, [{
    key: "generateView",
    value: function generateView(sceneView, option) {
      this.view_ = sceneView;
      if (!option || option === 'workspace' || option === 'playground') {
        var blockCountView = Entry.createElement('span').addClass('blockCountView');
        this.view_.appendChild(blockCountView);
        this.blockCountView = blockCountView;
        this.updateView();
      }
    }
  }, {
    key: "updateView",
    value: function () {
      var _updateView = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var blocks, count, langText;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.blockCountView) {
                _context.next = 2;
                break;
              }
              _context.next = 1;
              return Entry.Utils.getObjectsBlocksForEventThread();
            case 1:
              blocks = _context.sent;
              count = (0, _get2["default"])(blocks, 'length', 0);
              langText = Lang.Workspace.use_blocks_project;
              if (count === 1) {
                langText = Lang.Workspace.use_block_project;
              }
              this.blockCountView.innerHTML = Entry.Utils.stringFormat(langText, "<strong>".concat(Entry.Utils.shortenNumber(count), "</strong>"));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateView() {
        return _updateView.apply(this, arguments);
      }
      return updateView;
    }()
  }, {
    key: "destroy",
    value: function destroy() {
      // 우선 interface 만 정의함.
    }
  }]);
}();